export const environment = {
    production: true,
    config: '/assets/config.json',
    client_id: 'client-portal',
    envName: 'production'
};
